<div class="container">
  <mic-breadcrumb id="casing-purchase-setup-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link
      link="/home/productData/casingPurchase"
      label="{{ translationService.translate('casingPurchaseText') }}"
    ></mic-breadcrumb-link>
    <mic-breadcrumb-link
      link="/home/productData/casingPurchase"
      label="{{ translationService.translate('casingPurchaseSetupText') }}"
    ></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h2 class="page-title" id="casing-purchase-setup-heading">{{ translationService.translate('casingPurchaseSetupText') }}</h2>

  <div class="w-full flex flex-row items-center justify-between">
    <p id="casing-purchase-info">
      <b>
        <span class="casing-purchase-label">{{ translationService.translate('codeText') }}: </span>
        <span class="casing-purchase-value">{{ code }} | </span>
        <span class="casing-purchase-label">{{ translationService.translate('descriptionText') }}: </span>
        <span class="casing-purchase-value">{{ description }}</span>
      </b>
    </p>
    <div class="action-bar">
      <button
        id="clear-filters"
        type="button"
        mat-flat-button
        color="accent"
        (click)="clearFilters()"
        class="clear-filters-button btn-clear"
      >
        <mat-icon>refresh</mat-icon> {{ translationService.translate('clearFiltersText') }}
      </button>
      <button id="cancel" class="btn-cancel" mat-flat-button (click)="cancel()">
        <mat-icon>cancel</mat-icon> {{ translationService.translate('cancelLinkText') }}
      </button>
      <!-- Save button visible but DISABLED (view-only story) -->
      <span
        [matTooltip]="
          productSaveDisabled
            ? this.translationService.translate('comingSoonText')
            : !saveEnabled
            ? this.translationService.translate('userCannotSaveText')
            : null
        "
      >
        <button
          id="save"
          class="btn-primary"
          type="button"
          mat-flat-button
          color="primary"
          [disabled]="!saveEnabled || isCreateInProgress"
          (click)="save()"
        >
          <mat-icon>save</mat-icon>
          {{ translationService.translate('saveLinkText') }}
        </button>
      </span>
      <button id="export-button" class="btn-export" mat-flat-button color="primary" (click)="openExportModal()">
        <mat-icon>download</mat-icon>
        {{ translationService.translate('exportButtonText') }}
      </button>
    </div>
  </div>

  <mat-card class="search-card mt-3">
    <form [formGroup]="filterForm" style="display: flex; align-items: flex-start">
      <div class="grid-container" style="flex: 1">
        <app-dropdown-search-single-select
          id="size"
          label="{{ translationService.translate('sizeText') }}"
          emptyPlaceholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('sizeText') }}"
          placeholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('sizeText') }}"
          [formGroup]="filterForm"
          formControlName="size"
          [data]="sizeList"
        >
        </app-dropdown-search-single-select>
        <app-dropdown-search-single-select
          id="description"
          label="{{ translationService.translate('descriptionText') }}"
          emptyPlaceholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('descriptionText') }}"
          placeholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('descriptionText') }}"
          [formGroup]="filterForm"
          formControlName="description"
          [data]="descriptionList"
        >
        </app-dropdown-search-single-select>
        <app-dropdown-search-single-select
          id="purchasePrice"
          label="{{ translationService.translate('purchasePriceText') }}"
          emptyPlaceholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('purchasePriceText') }}"
          placeholder="{{ translationService.translate('selectText') + ' ' + translationService.translate('purchasePriceText') }}"
          [formGroup]="filterForm"
          formControlName="casingPrice"
          [data]="purchasePriceList"
        >
        </app-dropdown-search-single-select>
      </div>
    </form>
  </mat-card>

  <div id="casing-purchase-setup-table" class="cam-table table-container">
    <mic-table #paginatedTable class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'purchasePrice'">
        <input
          subscriptSizing="dynamic"
          id="PurchasePriceInput"
          matInput
          type="text"
          min="0"
          step="0.01"
          pattern="^\\d+(\\.\\d{1,2})?$"
          maxlength="6"
          [formControl]="getControl(item, 'purchasePrice')"
          [readonly]="!saveEnabled"
          (keydown)="handleKeydown($event)"
          (input)="restrictTwoDecimalPlaces($event, item)"
        />
      </ng-container>
    </mic-table>
  </div>

  <!-- Discard Changes Modal -->
  <mic-modal class="modalC" #discardConfirmation (result)="onDiscardModalClosed($event)"></mic-modal>
  <ng-template #discardContent>{{ translationService.translate('unSaveChangesText') }}</ng-template>
</div>
